import React from "react";
import ZButton from "@atoms/ZButton";
import {
	getZomentumEntityDisplayValue,
	TriggerActionEntityTypes,
	ZomentumEntities
} from "@/Contracts";
import ZModal from "@atoms/ZModal";
import { IBulkActionBarProps } from "./interface";
import ZTypography from "@atoms/ZTypography";
import RoleBasedDisplayWrapper from "@/Components/UI/RoleBasedDisplayWrapper";
import { UserRole } from "@/Contracts/Users";
import "./index.less";
import useMobileView from "@/Hooks/useMobileView";
import { Col, Row } from "antd";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { ZIcon } from "@atoms";
import { Icons } from "@atoms/ZIcon";
import { EColors } from "@atoms/ZColors/interface";

const { ZText } = ZTypography;

const ZBulkActionsBar: React.FC<IBulkActionBarProps> = props => {
	const handleRecordSelection = (value: boolean) => {
		if (props.handleRecordSelection) props.handleRecordSelection(value);
	};

	const getDescription = (
		zomentumEntity: TriggerActionEntityTypes | undefined | null
	) => {
		return !!zomentumEntity?.length
			? zomentumEntity === ZomentumEntities.Client
				? "and all associated Contacts, Opportunities, and Documents "
				: zomentumEntity === ZomentumEntities.Document
				? "and all associated Payments "
				: zomentumEntity === ZomentumEntities.Opportunity
				? "and all associated Contacts, and Documents "
				: ""
			: "";
	};

	const confirmDelete = () => {
		ZModal.confirm({
			title: "Are you certain you want to proceed with this irreversible deletion?",
			content: (
				<ZText>
					By proceeding, the selected {props.selectedRecords}{" "}
					{getZomentumEntityDisplayValue(
						props.entity,
						!props.selectedRecords
					)}{" "}
					{getDescription(props.entity)}
					will be{" "}
					<ZText weight={EFontWeights.SEMIBOLD}>
						permanently
					</ZText>{" "}
					deleted. This action cannot be undone.
				</ZText>
			),
			onOk: props?.handleDelete,
			okType: "danger",
			okText: "Delete",
			icon: (
				<span className="anticon anticon-question-circle">
					<ZIcon
						name={Icons.WARNINGCIRCLE}
						color={EColors.RED}
						colorVariant={6}
					/>
				</span>
			)
		});
	};

	const isMobileView = useMobileView();

	return (
		<Row className={`bulk-action-bar ${isMobileView ? "mobile-view" : ""}`}>
			<Col flex="243px">
				{props.featureAccess?.bulkUpdate && (
					<ZButton
						className="mr-2"
						onClick={props.openBulkUpdateDrawer}
					>
						Bulk Update
					</ZButton>
				)}
				{props?.handleDelete && (
					<RoleBasedDisplayWrapper
						requiredRole={UserRole.SecondaryRole}
					>
						{props.featureAccess?.bulkDelete && (
							<ZButton danger onClick={confirmDelete}>
								Bulk Delete
							</ZButton>
						)}
					</RoleBasedDisplayWrapper>
				)}
			</Col>
			{props.showInfoText && (
				<Col
					flex="auto"
					className="bg-gold-1 flex items-center justify-center"
				>
					{props.selectedRecords === props.totalRecords &&
					!props.selectAllRecords ? (
						<ZTypography.ZText>
							{props.selectedRecords}{" "}
							{getZomentumEntityDisplayValue(
								props.entity,
								!props.selectedRecords
							)}{" "}
							selected.
						</ZTypography.ZText>
					) : props.selectedRecords === props.totalRecords &&
					  props.selectAllRecords ? (
						<ZTypography.ZText>
							{props.totalRecords}{" "}
							{getZomentumEntityDisplayValue(
								props.entity,
								!props.totalRecords
							)}{" "}
							selected.{" "}
							<span onClick={() => handleRecordSelection(false)}>
								<ZTypography.ZLink>Undo</ZTypography.ZLink>
							</span>
						</ZTypography.ZText>
					) : (
						<ZTypography.ZText>
							{props.selectedRecords}{" "}
							{getZomentumEntityDisplayValue(
								props.entity,
								!props.selectedRecords
							)}{" "}
							selected.{" "}
							<span onClick={() => handleRecordSelection(true)}>
								<ZTypography.ZLink>
									Select all {props.totalRecords}{" "}
									{getZomentumEntityDisplayValue(
										props.entity,
										!props.totalRecords
									)}
								</ZTypography.ZLink>
							</span>
						</ZTypography.ZText>
					)}
				</Col>
			)}
		</Row>
	);
};

export default ZBulkActionsBar;
